export default "__VITE_ASSET__CpXlGVcr__"